import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Link, SecondaryButton } from '@aok/ui-elements'
import { ArrowUp, ArrowDown } from '@aok/icon-functional'

import MacroContainer from '../../_layout/Macro/MacroContainer'

import ArticleSharing from '../ArticleSharing/ArticleSharing'

const ArticleFooter = ({ tags, sources }) => {
  const [showSources, setShowSources] = useState(false)

  return (
    <MacroContainer>
      {tags && (
        <div className="flex flex-wrap mt-32 840:mt-48 mb-48 840:mb-64 -ml-16">
          {tags.map((tag, index) => (
            <SecondaryButton key={index} url={tag.url} className="mt-16 ml-16">
              {tag.title}
            </SecondaryButton>
          ))}
        </div>
      )}

      <hr className="text-dfe3e6 w-full" />

      <div className="flex justify-between pt-16 px-8 600:px-4 1280:px-0">
        <ArticleSharing />

        {sources && (
          <Link
            type="button"
            theme="secondary"
            title="Quellen"
            onClick={() => setShowSources(!showSources)}
            icon={showSources ? <ArrowUp className="ml-8" /> : <ArrowDown className="ml-8" />}
          />
        )}
      </div>

      {sources && showSources && <div dangerouslySetInnerHTML={{ __html: sources }} className="articleSources mt-32" />}
    </MacroContainer>
  )
}

ArticleFooter.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  sources: PropTypes.string,
}

ArticleFooter.defaultProps = {}

export default ArticleFooter
